import { Button, Result } from 'antd'
import { useNavigate } from '@tanstack/react-router'
import { HOME_PATH } from '@/router/guards'

// 缺少页面要求的权限时在内容区显示，不白屏
export function ForbiddenResult() {
  const navigate = useNavigate()
  return (
    <Result
      status="403"
      title="没有访问权限"
      subTitle="您没有访问此页面的权限，如需开通请联系超级管理员。"
      extra={
        <Button type="primary" onClick={() => navigate({ to: HOME_PATH })}>
          返回首页
        </Button>
      }
    />
  )
}
